<template>
    <section class="table">


        <div class="box">
            <div class="table__header">
                <h1>{{ title }}</h1>
                <div class="btns">
                    <router-link
                        v-if="hasPermission('Projects', 'insert')"
                        class="btn"
                        :to="{ name: 'projectForm', params: { action: 'create' } }"
                    >
                        <i class="fal fa-plus-circle"></i>
                    </router-link>
                </div>
            </div>

            <div class="table__content">
                <div style="display:flex; align-items: center;">
                    <div style="display: flex; align-items: center">
                        <span style="margin-right: 15px;">Export:</span>
                        <a
                            class="btn"
                            flat="flat"
                            style="white-space: nowrap; margin-right:10px; text-align: center;"
                            :href="`${baseUrl}/export-csv`"

                        >
                            <i class="fal fa-file-excel"></i> full data
                        </a>
                        <a
                            class="btn"
                            flat="flat"
                            style="white-space: nowrap; margin-right:10px; text-align: center;"
                            :href="`${baseUrl}/export-csv-sites`"
                        >
                            <i class="fal fa-file-excel"></i> sites
                        </a>
                        <a
                            class="btn"
                            flat="flat"
                            style="white-space: nowrap; margin-right:10px; text-align: center;"
                            :href="`${baseUrl}/export-csv-hotels`"
                        >
                            <i class="fal fa-file-excel"></i> hotels
                        </a>
                        <a
                            class="btn"
                            flat="flat"
                            style="white-space: nowrap; margin-right:10px; text-align: center;"
                            :href="`${baseUrl}/export-csv-groups`"
                        >
                            <i class="fal fa-file-excel"></i> groups
                        </a>
                    </div>

                    <div class="searchInput">
                        <div class="searchInput__inner">
                            <v-text-field
                                v-model="search"
                                append-icon="search"
                                label="Cerca"
                                single-line
                                hide-details
                            ></v-text-field>
                        </div>
                    </div>
                </div>

                <v-data-table
                    :headers="headers"
                    :items="projects"
                    :search="search"
                    class="elementTable"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="pagination"
                >
                    <template v-slot:items="props">
                        <td style="width: 20px;">{{ props.item.active == 1 ? 'Attivo' : 'Disattivo' }}</td>
                        <td style="width: 20px;">
                            <div
                                :style="getDotStyle(props.item.status)"
                            ></div>
                        </td>
                        <td style="width: 20px;">
                            <div
                                :style="getDotStyle(props.item.statusBe)"
                            ></div>
                        </td>
                        <td>{{ props.item.project }}</td>
                        <td class="tdPlatform">{{ props.item.platform }}</td>
                        <td v-html="'<div class=\'p-10\'>' +props.item.projectSite.replace(/,/g, '<br>')+ '</div>'"></td>
                        <td v-if="canEditOrDelete" class="action">
                            <div class="actions">
                                <router-link
                                    v-if="hasPermission('Projects', 'edit')"
                                    class="button icon btn_success"
                                    :to="{ name: 'projectForm', params: { id: props.item.id, action: 'edit' } }"
                                >
                                    <i class="fal fa-edit"></i>
                                </router-link>
                                <router-link
                                  v-if="hasPermission('Projects', 'chanel')"
                                  class="button icon btn_warning"
                                  :to="{ name: 'projectChanel', params: { id: props.item.id } }"
                                >
                                <i class="fal fa-tools"></i>
                                </router-link>
                                <a
                                    v-if="hasPermission('Projects', 'delete')"
                                    class="button icon btn_danger"
                                    @click.stop="nameSelected = props.item.project; idSelected = props.item.id; dialog = true"
                                >
                                    <i class="fal fa-trash-alt"></i>
                                </a>
                            </div>
                        </td>
                    </template>
                </v-data-table>
            </div>
        </div>


        <!-- MODALE LIBRARYFORM -->
        <div v-if="dialog" class="modal-overlay" @click.self="dialog = false">
            <div class="modal modal-confirm">

                <!-- HEADER -->
                <div class="modal-header">
                    <span class="headline">Sei sicuro?</span>
                    <button class="close-btn" @click="dialog = false">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
                <!-- BODY -->
                <div class="modal-body">
                    <div style="margin-bottom: 20px">L'elemento <strong>{{ nameSelected }}</strong> verrà eliminato e non potrà essere ripristinato</div>
                    <div class="flex-gap">
                        <button class="button button-p" @click="idSelected = null; dialog = false">Annulla</button>
                        <button class="button button-p" @click="deleteProject(idSelected); dialog = false">Ok cancella</button>
                    </div>
                </div>
            </div>
        </div>





    </section>
</template>

<script>
import exportFromJSON from "export-from-json";
import { mapGetters } from 'vuex';
import LibraryForm from "@/views/modules/Libraries/form.vue";

export default {
    name: 'listProject',
    components: {LibraryForm},

    data () {
        return {
            title: 'Progetti',
            dialog: false,
            idSelected: null,
            nameSelected: null,
            search: localStorage.getItem('projectSearch') || '',
            rowsPerPageItems: [20, 40, 60, { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }],
            pagination: {
                rowsPerPage: 20,
                sortBy: 'project',
                descending: false
            }
        }
    },

    computed: {
        ...mapGetters('projectsModule', ['projects']),
        ...mapGetters(['hasPermission']),
        baseUrl() {
            let url = process.env.VUE_APP_API_URL || '';
            if (url.endsWith('/api/')) {
                url = url.slice(0, -5);
            }
            return url;
        },
        canEditOrDelete() {
            return this.hasPermission('Projects', 'edit') || this.hasPermission('Projects', 'delete');
        },

        headers() {
            const base = [
                { text: 'Stato', align: 'left', value: 'active' },
                { text: 'Sito', align: 'center', value: 'status' },
                { text: 'BE', align: 'center', value: 'statusBe' },
                { text: 'Nome', align: 'left', value: 'project' },
                { text: 'Piattaforma', align: 'left', value: 'platform' },
                { text: 'Siti', align: 'left', value: 'projectSite' },
            ];
            if (this.canEditOrDelete) {
                base.push({ text: '', sortable: false });
            }
            return base;
        }
    },

    methods: {
        loadProjects () {
            this.$store.dispatch('projectsModule/loadProjects', { urlToConnect: 'projects' });
        },
        deleteProject(id) {
            const parameters = {
                urlToConnect: 'projects/' + id,
                methodToConnect: 'delete',
                _method: "delete"
            };
            this.idSelected = null;
            this.nameSelected = null;
            this.$store.dispatch('projectsModule/deleteProject', parameters);
        },
        downloadFile() {
            const data = this.projects;
            const fileName = "projects";
            const exportType = exportFromJSON.types.csv;
            if (data) exportFromJSON({ data, fileName, exportType });
        },
        getDotStyle(status) {
            let color = 'red';
            if (status == 2) color = 'green';
            else if (status == 1) color = 'orange';

            return {
                width: '10px',
                height: '10px',
                background: color,
                borderRadius: '50%',
                margin: '0 auto'
            };
        }
    },

    watch: {
        search(newVal) {
            localStorage.setItem('projectSearch', newVal);
        },
        '$route'() {
            this.loadProjects();
        }
    },

    created() {
        this.loadProjects();
        this.$store.dispatch('projectsModule/resetProject');
    }
}
</script>



